import React, { lazy } from 'react';
import { BrowserRouter as Router, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import History from './History';
import { loginAgain, logout } from './redux/actions/authActions';

import MainTemplate from './MainTemplate';

const Main = lazy(() => import('./views/Main/Main'));
const Working = lazy(() => import('./views/Main/Working'));

const MainSettings = lazy(() => import('./views/Main/MainSettings'));

/**
 * Auth
 */
const Login = lazy(() => import('./views/Auth/Login'));
const JoinAgree = lazy(() => import('./views/Auth/JoinAgree'));
const JoinForm = lazy(() => import('./views/Auth/JoinForm'));
const JoinJudge = lazy(() => import('./views/Auth/JoinJudge'));
const ChangePW = lazy(() => import('./views/Auth/ChangePW'));

const Mypage = lazy(() => import('./views/Mypage/Mypage'));

/**
 * Event
 */
const EventList = lazy(() => import('./views/Competitions/EventList'));
const Information = lazy(() => import('./views/Competitions/Information'));
const EventSchedule = lazy(() => import('./views/Competitions/EventSchedule'));
const Entry = lazy(() => import('./views/Ovr/Entry'));
const Drawsheet = lazy(() => import('./views/Competitions/Drawsheet'));
const Schedule = lazy(() => import('./views/Competitions/Schedule'));
const Results = lazy(() => import('./views/Competitions/Results'));
const Photo = lazy(() => import('./views/Competitions/Photo'));
const Video = lazy(() => import('./views/Competitions/Video'));
const News = lazy(() => import('./views/Competitions/News'));
const Notice = lazy(() => import('./views/Competitions/Notice'));

const Division = lazy(() => import('./views/Ovr/Division'));
const GroupManagement = lazy(() => import('./views/Ovr/GroupManagement'));
const VideoManagement = lazy(() => import('./views/Ovr/VideoManagement'));
const ScheduleManagement = lazy(() => import('./views/Ovr/ScheduleManagement'));
const EntryGroupManagement = lazy(() =>
  import('./views/Ovr/EntryGroupManagement'),
);
const RuleManagement = lazy(() => import('./views/Ovr/RuleManagement'));
const DrawsheetManagement = lazy(() =>
  import('./views/Ovr/DrawsheetManagement'),
);
const MatchResultManagement = lazy(() =>
  import('./views/Ovr/MatchResultManagement'),
);
const MatchesManagement = lazy(() => import('./views/Ovr/MatchesManagement'));
const OperatorManagement = lazy(() => import('./views/Ovr/OperatorManagement'));
const RefereeManagement = lazy(() => import('./views/Ovr/RefereeManagement'));

const BroadcastManagement = lazy(() =>
  import('./views/Ovr/BroadcastManagement'),
);

const ScorePage = lazy(() => import('./views/Score/ScorePage'));
const ScorePageRef = lazy(() => import('./views/Score/ScorePageRef'));
const ScorePageRefRemote = lazy(() => import('./views/Score/ScorePageRefRemote'));
const ScorePageMonitor = lazy(() => import('./views/Score/ScorePageMonitor'));

/**
 * Application
 */
const Application = lazy(() => import('./views/TempateTypeA/Application'));
const ApplicationDivision = lazy(() =>
  import('./views/TempateTypeA/ApplicationDivision'),
);
const ApplicationInfo = lazy(() =>
  import('./views/TempateTypeA/ApplicationInfo'),
);
const ApplicationPlayer = lazy(() =>
  import('./views/TempateTypeA/ApplicationPlayer'),
);

/**
 * OVR
 */
const AccountList = lazy(() => import('./views/Mypage/AccountList'));
const RuleList = lazy(() => import('./views/Mypage/RuleList'));
const Events = lazy(() => import('./views/Mypage/Events'));

/**
 * 심판 테스트 경기
 */
const RefereeManagementDemo = lazy(() =>
  import('./views/ScoreDemo/RefereeManagement'),
);
const ScorePageRefDemo = lazy(() => import('./views/ScoreDemo/ScorePageRef'));

class AppRouter extends React.Component {
  componentWillMount() {
    this.validateUserSession();
  }

  validateUserSession() {
    if (localStorage.getItem('kpnp-token') != null) {
      this.props.loginAgain(
        JSON.parse(localStorage.getItem('kpnp-token')),
        'kpnp-token',
      );
    }
  }

  render() {
    return (
      // Set the directory path if you are deploying in sub-folder
      <Router history={History}>
        <Switch>
          <MainTemplate exact path="/kpnp" component={Working} />
          <MainTemplate exact path="/community" component={Working} />

          <MainTemplate exact path="/login" component={Login} />
          <MainTemplate exact path="/join_agree" component={JoinAgree} />
          <MainTemplate exact path="/join_form" component={JoinForm} />
          <MainTemplate exact path="/join_judge" component={JoinJudge} />

          <MainTemplate exact path="/verification" component={ChangePW} />

          <MainTemplate exact path="/mypage" component={Mypage} />

          {/* Event */}
          <MainTemplate exact path="/event" component={EventList} />
          <MainTemplate
            exact
            path="/competition/:code"
            component={Information}
          />
          <MainTemplate
            exact
            path="/competition/:code/information"
            component={Information}
          />

          <MainTemplate
            exact
            path="/competition/:code/division"
            component={Division}
          />

          <MainTemplate
            exact
            path="/competition/:code/event"
            component={EventSchedule}
          />
          <MainTemplate
            exact
            path="/competition/:code/entry"
            component={Entry}
          />
          <MainTemplate
            exact
            path="/competition/:code/drawsheet"
            component={Drawsheet}
          />
          <MainTemplate
            exact
            path="/competition/:code/schedule"
            component={Schedule}
          />
          <MainTemplate
            exact
            path="/competition/:code/results"
            component={Results}
          />
          <MainTemplate
            exact
            path="/competition/:code/photo"
            component={Photo}
          />
          <MainTemplate
            exact
            path="/competition/:code/video"
            component={Video}
          />
          <MainTemplate exact path="/competition/:code/news" component={News} />
          <MainTemplate
            exact
            path="/competition/:code/notice"
            component={Notice}
          />

          {/* ADMIN MENU */}
          <MainTemplate
            exact
            path="/competition/:code/group_management"
            component={GroupManagement}
          />
          <MainTemplate
            exact
            path="/competition/:code/video_management"
            component={VideoManagement}
          />
          <MainTemplate
            exact
            path="/competition/:code/schedule_management"
            component={ScheduleManagement}
          />
          <MainTemplate
            exact
            path="/competition/:code/entry_group_management"
            component={EntryGroupManagement}
          />
          <MainTemplate
            exact
            path="/competition/:code/rule_management"
            component={RuleManagement}
          />
          <MainTemplate
            exact
            path="/competition/:code/drawsheet_management"
            component={DrawsheetManagement}
          />
          <MainTemplate
            exact
            path="/competition/:code/matchresult_management"
            component={MatchResultManagement}
          />
          <MainTemplate
            exact
            path="/competition/:code/matches_management"
            component={MatchesManagement}
          />

          <MainTemplate
            exact
            path="/competition/:code/broadcast"
            component={BroadcastManagement}
          />

          <MainTemplate
            exact
            path="/competition/:code/operator_page"
            component={OperatorManagement}
          />
          <MainTemplate
            exact
            path="/competition/:code/referee_page"
            component={RefereeManagement}
          />

          <MainTemplate
            exact
            path="/competition/:code/score/running"
            component={ScorePage}
          />

          <MainTemplate
            exact
            path="/competition/:code/score/referee"
            component={ScorePageRef}
          />

          <MainTemplate
            exact
            path="/competition/:code/score/referee_remote/:matchId"
            component={ScorePageRefRemote}
          />

          <MainTemplate
            exact
            path="/competition/:code/score/monitor"
            component={ScorePageMonitor}
          />

          <MainTemplate
            exact
            path="/mainpage/settings"
            component={MainSettings}
          />

          {/* TEMP */}
          <MainTemplate
            exact
            path="/competition/:code/entry"
            component={Entry}
          />

          {/* OVR */}
          <MainTemplate exact path="/ovr/events" component={Events} />
          <MainTemplate
            exact
            path="/ovr/account_list"
            component={AccountList}
          />
          <MainTemplate exact path="/ovr/rule_list" component={RuleList} />

          {/* Application */}
          <MainTemplate
            exact
            path="/site/:code/application"
            component={Application}
          />
          <MainTemplate
            exact
            path="/site/:code/application_division"
            component={ApplicationDivision}
          />
          <MainTemplate
            exact
            path="/site/:code/application_info"
            component={ApplicationInfo}
          />
          <MainTemplate
            exact
            path="/site/:code/application_player"
            component={ApplicationPlayer}
          />

          {/* REF DEMO */}
          <MainTemplate
            exact
            path="/demo/referee_page_demo"
            component={RefereeManagementDemo}
          />

          <MainTemplate
            exact
            path="/demo/referee_page_demo/score"
            component={ScorePageRefDemo}
          />

          <MainTemplate path="/" component={Main} />
        </Switch>
      </Router>
    );
  }
}

AppRouter.propTypes = {
  loginAgain: PropTypes.func.isRequired,
};

const mapStateToPropsAppRouter = state => {
  return {
    authStatus: state.auth.login.login,
    profile: state.auth.login.values,
    user: state.auth.login,
  };
};
export default connect(mapStateToPropsAppRouter, { loginAgain })(AppRouter);
